import { Progress } from 'antd'
import AntdSteps from 'components/AntdSteps'
import { menuData } from 'modules/Onboarding/Register/Menu'
import {
  Heading,
  ProgressContainer,
  Wrapper,
} from 'modules/Onboarding/Register/style'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getFrozenFields } from 'modules/Resume/actions'
import {
  ContainerWrapper,
  ContentContainer,
  SubContainerWrapper,
  WrapperContainer,
} from './style'

const Register = ({
  studentData,
  studentDetails,
  getStudentData,
  updateStudentData,
  deleteFile,
  instituteDeatils,
  deleteEducation,
  getCollege,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  countryList = [],
  stateList = [],
  updateStatusPending,
  getFunctionsList,
  getDesignationsList,
  getIndustryList,
  updateCurrentState,
  getListOfSkills,
  getSkillList,
  updateCvDetails,
  getCorporateList,
  searchAPI,
  updateUserProfile,
  getCities,
  getPendingData,
  pendingData,
}) => {
  const dispatch = useDispatch()
  const frozenFields = useSelector(state => state.resume.frozenFields)
  
  const [containerHeight, setContainerHeight] = useState(
    `${window.innerHeight - 65}px`
  )

  const navigate = useNavigate()
  const params = useParams()
  const studentId = params.studentId
  const [current, setCurrent] = useState(0)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    getStudentData(studentId)
  }, [studentId])

  useEffect(() => {
    if (studentData?.id) {
      getPendingData()
      dispatch(getFrozenFields())
    } else {
      console.log('studentData.id not available yet')
    }
  }, [studentData?.id])

  useEffect(() => {
    if (studentData?.instituteCampusId) {
      getCollege(studentData?.instituteCampusId)
    }
  }, [studentData])

  useEffect(() => {
    if (studentData?.currentState === 0 || studentData?.currentState === -1) {
      navigate(`/onboarding/activate/${studentData?.id}`)
    } 
    // else if (studentData?.currentState === 1) {
    //   navigate(`/onboarding/final/${studentData?.id}`)
    // } else if (studentData?.currentState === 3) {
    //   navigate(`/onboarding/notification/${studentData?.id}`)
    // } else if (studentData?.currentState === 4) {
    //   navigate(`/dashboard`)
    // }
    else{
      navigate(`/dashboard`)
    }
  }, [studentData])

  useEffect(() => {
    // Function to update container height when window is resized
    const handleResize = () => {
      setContainerHeight(`${window.innerHeight - 65}px`)
    }

    // Add event listener for window resize
    window.addEventListener('resize', handleResize)

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <ContainerWrapper height={containerHeight}>
      <SubContainerWrapper column>
        <AntdSteps steps={menuData} current={current} />
      </SubContainerWrapper>
      {menuData?.map(item => {
        return (
          item?.activeKey === current && (
            <Wrapper column>
              <WrapperContainer row spaceBetween width="100%">
                <Heading>{item?.heading}</Heading>
                <ProgressContainer>
                  <Progress
                    percent={studentData?.profilePerCount?.profileCompleteRate}
                    size="small"
                    strokeColor={'#5DB594'}
                  />
                </ProgressContainer>
              </WrapperContainer>
              <ContentContainer>
                <item.component
                  setCurrent={setCurrent}
                  updateCvDetails={updateCvDetails}
                  studentData={studentData}
                  studentFormData={studentDetails}
                  updateStudentData={updateStudentData}
                  deleteFile={deleteFile}
                  instituteName={instituteDeatils?.campusName}
                  deleteEducation={deleteEducation}
                  countryList={countryList}
                  stateList={stateList}
                  getListOfCountries={getListOfCountries}
                  getListOfState={getListOfState}
                  getListOfCity={getListOfCity}
                  updateStatusPending={updateStatusPending}
                  updateCurrentState={updateCurrentState}
                  getListOfSkills={getSkillList}
                  activeKey={item.activeKey}
                  cvDetails={studentData?.cvDetails}
                  getCorporateList={getCorporateList}
                  searchAPI={searchAPI}
                  updateUserProfile={updateUserProfile}
                  setInitialLoading={setLoading}
                  initalLoading={loading}
                  getDesignationsList={getDesignationsList}
                  getFunctionsList={getFunctionsList}
                  getIndustryList={getIndustryList}
                  getStudentData={getStudentData}
                  getCities={getCities}
                  pendingData={pendingData}
                  frozenFields={frozenFields}
                />
              </ContentContainer>
            </Wrapper>
          )
        )
      })}
    </ContainerWrapper>
  )
}

export default Register
